import { type IdentityIssueRule, PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH } from "./auth";

// Rules of identity the apps apply too (pattern.md §4): the browser shows what the domain would refuse, with the same
// rules and codes. The domain still enforces them.

/** Enough for a laptop, a phone and two keys, with room: a list without end is only something to abuse (ADR-151). */
export const MAX_PASSKEYS = 10;

/** The length that counts (NIST SP 800-63B 5.1.1.2): characters after NFKC normalization, not bytes. */
export const passwordLength = (password: string): number => [...password.normalize("NFKC")].length;

/**
 * What is wrong with a new password before it is compared with the breaches (NIST SP 800-63B 5.1.1.2): its length in
 * characters after normalization, and the email of the account, or the part before the @ when it is long enough to
 * mean something. Without the email (the page of a link knows only its token) only the length.
 */
export function passwordIssues(password: string, email?: string): IdentityIssueRule[] {
  const length = passwordLength(password);
  const issues: IdentityIssueRule[] = [];
  if (length < PASSWORD_MIN_LENGTH) issues.push("too_short");
  if (length > PASSWORD_MAX_LENGTH) issues.push("too_long");
  if (email && containsEmail(password.normalize("NFKC").toLowerCase(), email)) issues.push("contains_email");
  return issues;
}

function containsEmail(password: string, email: string): boolean {
  const local = email.split("@")[0] ?? "";
  return password.includes(email) || (local.length >= 4 && password.includes(local));
}
